package amazon.lastmile.inject

import app.nestbridge.feature.children.service.ChildService
import app.nestbridge.feature.children.service.DefaultChildService
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = DefaultChildService::class)
public interface AppNestbridgeFeatureChildrenServiceDefaultChildService {
  @Provides
  public fun provideDefaultChildServiceChildService(defaultChildService: DefaultChildService): ChildService = defaultChildService
}
